/**
 * Compact timestamp for chat bubbles (e.g. "2:34 PM").
 * @param {import('firebase/firestore').Timestamp | Date | string | number | null | undefined} value
 */
export function formatChatMessageTime(value) {
  if (!value) return '';
  const date =
    typeof value?.toDate === 'function'
      ? value.toDate()
      : value instanceof Date
        ? value
        : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}
